const shouldStringify = {
  type: 'confirm',
  name: 'shouldStringify',
  message: 'Key content should be stringified?',
}

export default {
  shouldStringify,
}
